import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

class Home extends PureComponent {
  render() {
    return (
      <Redirect to="/tools/img2brs" />
    )
  }
}

export default Home